import { render } from "./CashierView.vue?vue&type=template&id=09541bd3&scoped=true"
import script from "./CashierView.vue?vue&type=script&lang=js"
export * from "./CashierView.vue?vue&type=script&lang=js"

import "./CashierView.vue?vue&type=style&index=0&id=09541bd3&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09541bd3"]])

export default __exports__